import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { config } from '../../utils/helpers/config.helpers'
import { useAccountDetails } from '../../utils/hooks/useAccountDetails.hooks'
import { StyledLink } from './AdminTooltip.styles'
import { toast } from 'react-toastify'
import { isImpersonating } from '../../utils/helpers/impersonation.helpers'

export const AdminTooltip = () => {
  const { t } = useTranslation(['app'], { useSuspense: false })
  const { metapicUserId, slug, userId } = useAccountDetails()

  useEffect(() => {
    if (isImpersonating()) {
      toast.info(
        <div>
          {t('app:admin_tooltip.description')}{' '}
          <StyledLink
            href={`${config.adminLegacyUrl}/creators/${metapicUserId}`}
          >
            {`#${metapicUserId} `}
          </StyledLink>
          {` ${slug} `}
          <StyledLink href={`${config.adminUrl}/creators`}>
            {t('app:admin_tooltip.back')}
          </StyledLink>
        </div>,
        {
          hideProgressBar: true,
          autoClose: false,
        }
      )
    }
  }, [slug, metapicUserId, userId, t])

  return null
}
